import { motion } from 'framer-motion'
import { fadeInUp, viewportOnce } from '../../utils/animations'

export default function SectionHeading({
  label,
  title,
  subtitle,
  align = 'center',
  light = false,
  className = '',
}) {
  const alignClass =
    align === 'center'
      ? 'text-center mx-auto'
      : align === 'end'
        ? 'text-end ms-auto'
        : 'text-start'

  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={viewportOnce}
      variants={fadeInUp}
      className={`mb-12 max-w-3xl ${alignClass} ${className}`}
    >
      {label && (
        <span
          className={`mb-3 inline-block rounded-full px-4 py-1.5 text-xs font-semibold uppercase tracking-widest ${
            light
              ? 'bg-white/15 text-white backdrop-blur-sm'
              : 'bg-primary/8 text-primary'
          }`}
        >
          {label}
        </span>
      )}
      <h2
        className={`text-2xl font-bold tracking-tight sm:text-3xl md:text-4xl lg:text-5xl ${
          light ? 'text-white' : 'text-gradient'
        }`}
      >
        {title}
      </h2>
      {subtitle && (
        <p
          className={`mt-4 text-lg leading-relaxed ${
            light ? 'text-white/85' : 'text-text/70'
          }`}
        >
          {subtitle}
        </p>
      )}
      <div
        className={`mt-6 h-1 w-16 rounded-full gradient-brand ${
          align === 'center' ? 'mx-auto' : align === 'end' ? 'ms-auto' : ''
        }`}
      />
    </motion.div>
  )
}
